var _defs, _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRedleftarrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#cc121d;}.b{fill:none;stroke:#fff;stroke-width:3px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M50,0A50,50,0,1,1,0,50,50,50,0,0,1,50,0Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(23.35 71.93) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M0,21.95S19.449,12.691,21.526,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M22.12,21.865S.086,8.9,0,0",
    transform: "translate(21.696 0.085)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M0,53.477V0",
    transform: "translate(21.699 0.17)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedleftarrow);
export default __webpack_public_path__ + "static/media/redleftarrow.8600e6ca9223626c2d89ae57ced9f5c9.svg";
export { ForwardRef as ReactComponent };